/**
 * Miledeep display date standard.
 *
 * UI Designer requirement:
 * Aug 05, 2026
 */
export function formatDate(value) {
  if (!value) return null;

  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) return null;

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
}


/**
 * Used where time is operationally useful while keeping
 * the same date style throughout the application.
 *
 * Example: Aug 05, 2026, 03:42 PM
 */
export function formatDateTime(value) {
  if (!value) return null;

  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) return null;

  return date.toLocaleString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
